<template>
  <div>
    <div class="mobile-menu__contacts" @click="showContacts">
      <div class="mobile-menu__contacts-title-wrap">
        <div class="mobile-menu__contacts-title">{{ $t('up.menu.contacts-title') }}</div>
        <div class="mobile-menu__contacts-subtitle">{{ $t('up.menu.contacts-subtitle') }}</div>
      </div>
      <div class="mobile-menu__contacts-arrow">
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M7.19114 2.02793L5.85938 3.35688L13.8462 11.3456L15.177 10.0138L7.19114 2.02699V2.02793Z" fill="#CCCCCC"/>
          <path d="M5.8584 16.6692L7.1911 18L15.176 10.0141L13.8452 8.68235L5.8584 16.6692Z" fill="#CCCCCC"/>
        </svg>
      </div>
    </div>
    <inner-level-menu
      :title="innerMenuTitle"
      :content="innerMenuContent"
      :is-open="innerMenuOpen"
      @hideCurrLevel="hideCurrLevelAction"
    ></inner-level-menu>
  </div>
</template>

<script>
import InnerLevelMenu from '@/components/header/InnerLevelMenu.vue'

export default {
  name: 'MobileMenuContacts',
  components: { InnerLevelMenu },
  data () {
    return {
      innerMenuTitle: {},
      innerMenuContent: [],
      innerMenuOpen: false
    }
  },
  methods: {
    openChat (e) {
      e.preventDefault()
      if (localStorage.getItem('zDChatStatus') === 'loaded' && this.$zendesk.isZe()) {
        this.$zendesk.open()
      } else {
        this.initChat()
      }
    },
    initChat () {
      this.$zendesk.load(process.env.VUE_APP_ZENDESK_KEY)
      if (localStorage.getItem('zDChatStatus') !== 'loaded') {
        let ttl = new Date()
        ttl.setHours(ttl.getHours() + 1)

        localStorage.setItem('zDChatStatusExpire', ttl.getTime())
        localStorage.setItem('zDChatStatus', 'loaded')
      }
    },
    showContacts () {
      this.innerMenuTitle = {
        text: this.$t('up.menu.contacts-title'),
        subtext: this.$t('up.menu.contacts-subtitle')
      }
      this.innerMenuContent = [
        // {
        //   name: 'Viber',
        //   full_url: 'viber://pa?chatURI=dnipro_m_bot',
        //   icon: '/img/svgo/header/mobile-menu-social/viber.svg',
        //   size: 25
        // },
        // {
        //   name: 'Telegram',
        //   full_url: 'https://telegram.me/dnipro_m_bot',
        //   icon: '/img/svgo/header/mobile-menu-social/telegram.svg',
        //   size: 25
        // },
        // {
        //   name: 'Facebook',
        //   full_url: 'https://m.me/795514890478433',
        //   icon: '/img/svgo/header/mobile-menu-social/facebook.svg',
        //   size: 25
        // },
        {
          name: 'E-mail',
          full_url: 'mailto:kontakt@dnipro-m.pl',
          icon: '/img/svgo/header/mobile-menu-social/email.svg',
          size: 25
        },
        {
          name: this.$t('header_sidebar_chat'),
          full_url: '',
          icon: '/img/svgo/header/mobile-menu-social/chat.svg',
          size: 25,
          action: this.openChat
        },
        {
          key: 'contacts_divider',
          divider: true
        },
        {
          name: '48 698 99 66 11',
          // subtitle: this.$t('header_sidebar_free_in_ukraine'),
          full_url: 'tel:+48698996611',
          icon: '/img/svgo/header/mobile-menu-social/phone.svg',
          size: 25
        }
      ]
      this.innerMenuOpen = true
    },
    hideCurrLevelAction () {
      this.innerMenuOpen = false
    }
  }
}
</script>

<style lang="sass" scoped>
.mobile-menu__contacts
  display: flex
  align-items: center
  justify-content: space-between
  padding: 10px 15px 15px 20px
  border-top: 1px solid #F3F3F3
  cursor: pointer
  background-color: #F8F8F8
  &-title
    color: #333333
    font-weight: 500
    font-size: 14px
    margin-bottom: 5px
  &-subtitle
    color: #909090
    font-size: 12px
    font-weight: 400
  &-arrow
    width: 24px
    height: 24px
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0
</style>
